import clsx from 'clsx'
import React from 'react'
import ReactPlayer from 'react-player/lazy'

import { ReactComponent as CloseIcon } from 'assets/icons/close-icon.svg'

import styles from './VideoModal.module.scss'
import { FullScreenModal } from '../FullScreenModal/FullScreenModal'
import { Icon } from '../Icon/Icon'

interface VideoModalProps {
  show: boolean
  setShow: (show: boolean) => void
  videoSrc: string
  setPlayVideo: (playVideo: boolean) => void
  playVideo: boolean
}

const VideoModal = ({ show, setShow, videoSrc, playVideo, setPlayVideo }: VideoModalProps) => {
  const [hover, setHover] = React.useState(false)

  const handleHover = () => {
    setHover(!hover)
  }

  return (
    <FullScreenModal open={show} className={styles.videoModal}>
      <div slot="header" className={styles.videoModalHeader}>
        <button
          onMouseEnter={handleHover}
          onMouseLeave={handleHover}
          onClick={() => {
            setPlayVideo(false)
            setShow(false)
          }}
        >
          <Icon icon={CloseIcon} className={clsx(styles.closeIcon, hover && styles.showCursor)} color="#4C4C4C" />
        </button>
      </div>
      <div slot="body" className="h-full relative">
        <ReactPlayer
          url={videoSrc}
          playing={playVideo}
          controls={true}
          width="100%"
          height="100%"
          className={styles.videoPlayer}
        />
      </div>
      <div slot="actions" />
    </FullScreenModal>
  )
}

export default VideoModal
